export const distinct = <T>(val: T, idx: number, self: T[]) => self.indexOf(val) === idx;
export const compareNum = (a: number | undefined, b: number | undefined) => (a ?? 0) - (b ?? 0);
export const compare = (a: string, b: string): number => a && b ? a.localeCompare(b) : a ? 1 : -1;
